module.exports = "pegasus/assets/themelp1/health/105.png";